import * as React from "react";

/**
 * Header override for the preview panel: the name of the file a .url link points at.
 *
 * The override is keyed to the item it was resolved for, so it disappears the moment the host
 * shows another item (close and reopen, arrow-key navigation) without depending on when the
 * panel's own reset callback fires. The setter is stable, so hosts can pass it straight to
 * `CMFilePreviewPanel`'s `onTargetResolved`.
 */
export const usePreviewTargetName = (item: unknown): [string | undefined, (name?: string) => void] => {
    const [entry, setEntry] = React.useState<{ item: unknown; name: string } | null>(null);
    const itemRef = React.useRef(item);
    itemRef.current = item;

    const setName = React.useCallback((name?: string) => {
        setEntry(name ? { item: itemRef.current, name } : null);
    }, []);

    return [entry && entry.item === item ? entry.name : undefined, setName];
};
